import Styles from './NodeAutomation.module.scss';
import NodeJenkinsStyles from '../NodeJenkins/NodeJenkins.module.scss';
import ImportedStyles from '../NodeTerminal/NodeTerminal.module.scss';
import CodeEditorStyles from '../NodeCodeEditor/NodeCodeEditor.module.scss';
import SeleniumEditorStyles from '../NodeEditorTerminal/seleniumEditor.module.scss';
import { useState, useRef, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// module imports
import axios from 'axios';
import _ from 'lodash';
import FeatherIcon from 'feather-icons-react';
import {
    Avatar, Typography, Backdrop, Badge, ListSubheader,
    List, ListItemButton, ListItemIcon, ListItemText,
    Collapse, Box, LinearProgress
} from '@mui/material';
import { pink } from '@mui/material/colors';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import RuleIcon from '@mui/icons-material/Rule';
import LaunchIcon from '@mui/icons-material/Launch';
import GridOnIcon from '@mui/icons-material/GridOn';
import ExpandLess from '@mui/icons-material/ExpandLess';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Python3Parser } from 'dt-python-parser';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import CloseIcon from '@mui/icons-material/Close';
import MonacoEditor from '@monaco-editor/react';
import { ToastContainer, toast } from 'react-toastify';
import { initializePyodide, runPythonScript } from './PyodideUtils';
import { initializeHtmlCss, runHtmlCss } from './initializeHtmlCss';
import ViewInArIcon from '@mui/icons-material/ViewInAr';

// component imports
import { AuthContext, ViewContext, useAPI } from 'components/lib';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import InfoDrawer from 'components/global/NodeLayout/InfoDrawer';
import { Joyride } from 'components/walkthrough/walkthrough';
import { NodeTimeline } from 'components/global/NodeLayout/NodeTimeline';
import { ConfirmationCard } from 'components/global/ConfirmationCard/ConfirmationCard';
import { MediaGrid } from 'components/global/NodeLayout/CodeEditorComponents/MediaGrid'
import NodeProgress from 'components/global/NodeLayout/NodeProgress/NodeProgress';
import { LightTooltip } from 'components/global/NodeLayout/NodeTopostman';
import { HelperChat } from 'components/global/HelperChat/HelperChat';
import { RenderFolderTree } from 'components/global/NodeLayout/CodeEditorComponents/FileTree';
import { BackConfirmationCard } from 'components/global/BackConfirmationCard/BackConfirmationCard';
import { Feedback } from 'components/lib';
import RevealAnswerKey from 'components/RevealAnswerKey/RevealAnswerKey';

// Util import.
import { decoder } from 'utils/helpers/decoder';
import { copyEnabledChecker } from 'utils/helpers/utility';

// assets
import failedAttemptSound from 'assets/sounds/try-again.mp3';
import { CodeBlock } from 'components/CodeBlock/CodeBlock';
import { InstructionPane } from 'components/global/InstructionPane/InstructionPane';
import ContainerLoader from 'components/ContainerLoader/ContainerLoader';

const finalAudio = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/media/git/voice/finish_node.mp3`;

export function NodeAutomation(props) {

    const { node_id } = useParams();
    const { lab_id } = useParams();
    const { resource } = useParams();
    const { job_id } = useParams()
    const parser = new Python3Parser();
    const context = useContext(AuthContext);

    // eslint-disable-next-line no-unused-vars
    const [htmlCssInstance, setHtmlCssInstance] = useState(null);

    const [steps, setSteps] = useState();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [nodeFinished, setNodeFinished] = useState(false);
    const [isMuted, setIsMuted] = useState(true);
    const [currentStep, setCurrentStep] = useState(0);
    const [isExecuted, setIsExecuted] = useState(false);
    const [transpiledCode, setTranspiledCode] = useState('');
    const [showOutput, setShowOutput] = useState(false);
    const [startLab, setStartLab] = useState(true);
    const [showReloadConfirm, setShowReloadConfirm] = useState(false);
    const [loadingContainerStart, setLoadingContainerStart] = useState(false);
    const [progress, setProgress] = useState(0);
    const [ipAddress, setIPAddress] = useState('');
    const activityTimerRef = useRef(null);
    const startActivityTimer = () => {
        activityTimerRef.current = setTimeout(handleInactivity, 1800000);
    };
    const [action, setAction] = useState('Output:');
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isWebPageOpen, setIsWebPageOpen] = useState(false);
    const [watcherData, setWatcherData] = useState([]);
    const [tableInfo, setTableInfo] = useState([
        {
            "tableName": "contact",
            "fields": [
                { "name": "id", "type": "INTEGER" },
                { "name": "email", "type": "VARCHAR" },
                { "name": "phone", "type": "VARCHAR" },
                { "name": "address", "type": "TEXT" }
            ]
        },
        {
            "tableName": "attendance",
            "fields": [
                { "name": "id", "type": "INTEGER" },
                { "name": "date", "type": "DATE" },
                { "name": "status", "type": "VARCHAR" }
            ]
        },
        {
            "tableName": "skills",
            "fields": [
                { "name": "id", "type": "INTEGER" },
                { "name": "skill_name", "type": "VARCHAR" },
                { "name": "experience_years", "type": "INTEGER" }
            ]
        },
    ]);

    const [open, setOpen] = useState('');
    const [showTables, setShowTables] = useState(false);

    const [liveAssessmentData, setLiveAssessmentData] = useState({
        assessmentData: [],
        score: 0
    })

    const viewContext = useContext(ViewContext)

    const currentRef = useRef(null);
    const outputRef = useRef(null);
    const isCopyEnabled = copyEnabledChecker(context?.user)
    const { data, loading } = useAPI(job_id ? `/api/hiring/jobs/assessment/${job_id}` : `/api/labs/${lab_id}/nodes/${node_id}/${resource}`, 'GET');
    const [nodeInfo, setNodeInfo] = useState();
    const [output, setOutput] = useState(props.t('Labs.Nodes.NodeAutomation.output.dummy'));
    const [pyodideInstance, setPyodideInstance] = useState(null);
    const [showFinishConfirm, setShowFinishConfirm] = useState(false);
    const roundedPercentage = nodeFinished ? 100 : Math.ceil(currentStep / nodeInfo?.numOfSteps * 100);
    const [copied, setCopied] = useState(false);

    const [showReveal, setShowReveal] = useState(false);
    const [maxUnlocked, setMaxUnlocked] = useState(0);
    const savedCode = useRef({});
    const [disableRunBtn, setDisableRunBtn] = useState(false);
    const modifiedCode = useRef({});
    const sessionId = localStorage.getItem('sessionId');
    const [readOnly, setReadOnly] = useState(false);
    const audioRef = useRef(null);
    const finalAudioRef = useRef(null);
    const isContainerLab = nodeInfo?.resource?.config?.containerConfig;
    const [loadingScreen, setLoadingScreen] = useState(false);

    useEffect(() => {
        setMaxUnlocked(prev => Math.max(prev, currentStep));
    }, [currentStep]);

    useEffect(() => {
        if (data) {
            const jsonData = decoder(data);
            jsonData.numOfSteps = jsonData.steps.steps.length;
            setSteps(jsonData.steps.steps);
            document.title = props.t('Labs.Nodes.NodeAutomation.title', { nodeName: jsonData.name })
            if (jsonData.status === 'completed' && (jsonData.numOfSteps === jsonData.userProgress)) {
                viewContext.notification.show(props.t('Labs.Nodes.NodeAutomation.notification.module_completed'), 'info', false);
                setReadOnly(true);
            }
            if (jsonData?.steps?.steps[currentStep]?.fileTree) {
                setWatcherData(jsonData.steps.steps[currentStep]?.fileTree)
            }
            if (jsonData?.userInputs) {
                savedCode.current = jsonData.userInputs;
            }
            setNodeInfo(jsonData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);


    useEffect(() => {
        if (nodeInfo?.resource?.config?.language === 'html') {
            initializeHtmlCss().then(instance => {
                setHtmlCssInstance(instance);
            });
        }

        if (nodeInfo?.resource?.config?.language === 'python') {
            initializePyodide().then(pyodide => {
                setPyodideInstance(pyodide);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodeInfo?.resource]);

    const handleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };

    const handleCopyButton = async () => {
        try {
            await navigator.clipboard.writeText(steps[currentStep]?.command);
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 2000);
            toast.dark(props.t('Labs.Nodes.NodeAutomation.toast.warn'), {
                type: 'warning',
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } catch (error) {
            toast.dark(props.t('Labs.Nodes.NodeAutomation.copyCode.alert'), {
                type: 'error',
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const handleCopy = async (e) => {
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 2000);
        toast.dark(props.t('Labs.Nodes.NodeAutomation.toast.warn'), {
            type: 'warning',
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const handleCopyDisabled = (e) => {
        e.preventDefault();
    }


    const handleVoiceClick = () => {
        setIsMuted(!isMuted);
    };

    // loading typescript with async only first time then regular call as gives the promise in output
    let tsLibraryLoaded = false;
    async function loadTypeScriptLibrary() {
        if (!tsLibraryLoaded) {
            const tsScript = document.createElement('script');
            tsScript.src = 'https://unpkg.com/typescript@latest/lib/typescript.js'; // calling unpkg to load typescript.js
            tsScript.type = 'text/javascript';
            tsScript.async = true;

            document.head.appendChild(tsScript);

            // Wait for the script to load before continuing
            await new Promise((resolve) => {
                tsScript.onload = resolve;
            });
            tsLibraryLoaded = true;
        }
    }

    const run = async (input) => {
        if (pyodideInstance) {
            const scriptText = input;
            const scriptOut = await runPythonScript(pyodideInstance, scriptText);
            return scriptOut;
        } else {
            return 'Initializing...';
        }
    };

    const runJava = async (input, stdin) => {
        try {
            const response = await axios.post(
                '/api/container-instances/java/verify',
                {
                    user_ip: ipAddress,
                    code: input,
                    stdin: stdin || ""
                },
                {
                    headers: {
                        accept: 'application/json',
                    },
                }
            )

            return response.data;

        } catch (err) {
            const errorData = {
                error: props.t("Labs.Nodes.NodeAutomation.container.error.notReachable"),
                notify: true
            };
            if (errorData?.notify) {
                viewContext.notification.show(errorData.error, 'error', true);
            };
            return {
                stderr: errorData.error || "Execution failed"
            };
        };
    };
    const runUserCodeWithWorker = (jsInput) => {
        const workerCode = `
        const capturedConsoleMessages  = [];

        self.addEventListener('message', async (event) => {
            const userCode = event.data;

            // Intercept console.log and send messages back to the main thread
            function captureConsoleLog() {
                const originalConsoleLog = console.log;
                console.log = function(...args) {
                    message = args.map(arg => {
						if (typeof arg === 'undefined') {
							return 'undefined';
						} else if (arg instanceof Set) {
                            const values = [...arg].map(function(v) {
                                if (typeof v === 'string') return "'" + v + "'";
                                if (typeof v === 'number' || typeof v === 'boolean') return String(v);
                                if (Array.isArray(v)) return '[' + v.map(function(e) { return JSON.stringify(e); }).join(', ') + ']';
                                if (typeof v === 'object' && v !== null) return JSON.stringify(v);
                                return String(v);
                            });
                            return 'Set(' + arg.size + ') {' + values.join(', ') + '}';
                        } else if (arg instanceof Map) {
                        const entries = [];
                        arg.forEach(function(value, key) {
                            const keyStr = (typeof key === 'string') ? "'" + key + "'" : String(key);
                            const valStr = (typeof value === 'string') ? "'" + value + "'" : String(value);
                            entries.push(keyStr + ' => ' + valStr);
                        });
                        return 'Map(' + arg.size + ') {' + entries.join(', ') + '}';
                        }    
                        else if (typeof arg === 'object') {
							return JSON.stringify(arg);
						} else {
							return arg;
						}
					}).join(' ');
					capturedConsoleMessages.push(message + '\\n')
                    originalConsoleLog.apply(console, args);
                };
            }

            try {
                // Capture console.log messages
                captureConsoleLog();

                // Execute user-provided code
                const result = await new Promise(resolve => resolve(eval(userCode)));
                self.postMessage({ result, capturedConsoleMessages  });
            } catch (error) {
                self.postMessage({ error: '' + error.name + ': ' + error.message, capturedConsoleMessages  });
            }
        });
    `;

        const blob = new Blob([workerCode], { type: 'application/javascript' });
        const worker = new Worker(URL.createObjectURL(blob));

        worker.addEventListener('message', (event) => {
            const { error, capturedConsoleMessages } = event.data;
            if (error) {
                setOutput(error);
            } else {
                setOutput(capturedConsoleMessages);
            }
            worker.terminate();
        });

        worker.postMessage(jsInput); // Use jsInput passed
    };

    function transpileTypeScriptToJavaScript(tsCode) {
        return new Promise(async (resolve) => {
            await loadTypeScriptLibrary();

            // Now that the TypeScript library is loaded, use it to transpile
            const jsCode = window.ts.transpile(tsCode, { target: 'es2022', strict: true });
            resolve(jsCode);
        });
    }

    const wastedAttemptAudio = new Audio(failedAttemptSound);

    function handleIncorrectAttempt() {
        wastedAttemptAudio.play();
        toast.dark(props.t('Labs.Nodes.NodeAutomation.toast.error'), {
            type: 'error',
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    const handleRun = async (resource) => {
        let userInput = savedCode.current[currentStep] ?? '';
        //If it is Automation (Selenium, Playwright), then it is just playback. Compare code and exit early
        if (resource?.config?.isAutomation) {
            const isInputCorrect = inputCompare(userInput);
            if (!isInputCorrect)
                return handleIncorrectAttempt();
            setIsExecuted(true);
            setShowOutput(true);
            return;  // Early exit
        }

        let compiledOut;
        switch (resource?.config?.language) {
            case 'python':
                if (resource?.config?.dbRequired) {
                    getTableInfo();

                    const pySQLInputCorrect = inputCompare(userInput);
                    if (!pySQLInputCorrect) {
                        return handleIncorrectAttempt();
                    }

                    const stepOutput = steps[currentStep]?.output;
                    if (stepOutput) {
                        setOutput(stepOutput);
                        break; // exit early
                    }
                    // If no stepOutput, fall through to execute
                }

                // If dbRequired is false OR no stepOutput was found
                compiledOut = await run(userInput);
                setOutput(compiledOut);
                break;

            case 'java':
                let stdin = "";
                if (needsInput(userInput)) {
                    stdin = window.prompt("Enter input:");

                    if (stdin === null) return;
                }
                const result = await runJava(userInput, stdin);
                setOutput((result.stdout || result.stderr)?.trim());
                break;

            case 'javascript':
                runUserCodeWithWorker(userInput);
                break;

            case 'typescript':
                const transpiledCodeBlock = await transpileTypeScriptToJavaScript(userInput);
                setTranspiledCode(transpiledCodeBlock);
                runUserCodeWithWorker(transpiledCodeBlock);
                break;

            case 'html':
                compiledOut = await runHtmlCss(userInput);
                setOutput(compiledOut);
                break;

            default:
                toast.dark(props.t('Labs.Nodes.NodeAutomation.toast.invalid'), {
                    type: 'error',
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
        }

        setIsExecuted(true);
        setShowOutput(true);
    };

    const getTableInfo = () => {
        if ('table' in steps[currentStep]) {
            setTableInfo(prevTableInfo => [
                ...prevTableInfo,
                ...steps[currentStep].table.filter(table => (
                    !prevTableInfo.some(existingTable => existingTable.tableName === table.tableName)
                )).map(table => ({
                    tableName: table.tableName,
                    fields: table.fields
                }))
            ])
        }
    }

    const moveToNext = () => {
        if (currentStep === nodeInfo.numOfSteps - 1) {
            modifiedCode.current[currentStep] = savedCode.current[currentStep];
            if (maxUnlocked === nodeInfo.numOfSteps - 1) setMaxUnlocked(prev => prev + 1)
            setNodeFinished(true);
            return;
        }
        modifiedCode.current[currentStep] = savedCode.current[currentStep];
        setCurrentStep(currentStep + 1);
        if (steps[currentStep]?.fileTree) {
            setWatcherData(steps[currentStep]?.fileTree)
        }
    };

    const needsInput = (code) => {
        return /Scanner|nextInt|nextLine|nextDouble/.test(code);
    };

    //function to compare the input
    const inputCompare = (input) => {

        // \r\n is package specific as the parser expects it at each line break
        const userCodeTokens = parser.getAllTokens(input + '\r\n');
        // Filtering out only the tokens by removing spaces and the \r\n after parsing
        const userTokensArray = userCodeTokens
            .map((obj) => obj['text'])
            .filter((text) => text.trim() !== '' && text !== '\r\n');

        const expectedInputTokens = parser.getAllTokens(steps[currentStep].exp_input + '\r\n');
        const expectedInputArray = expectedInputTokens
            .map((obj) => obj['text'])
            .filter((text) => text.trim() !== '' && text !== '\r\n');

        //Comparing user code tokens against expected code tokens
        return _.isEqual(_.sortBy(expectedInputArray), _.sortBy(userTokensArray));
    };

    //function to compare the output
    const outputCompare = (output) => {
        const outputTokens = parser.getAllTokens(output + '\r\n');
        const outputTokensArray = outputTokens
            .map((obj) => obj['text'])
            .filter((text) => text.trim() !== '' && text !== '\r\n');

        const expectedOutputTokens = parser.getAllTokens(steps[currentStep].exp_output + '\r\n');
        const expectedOutputArray = expectedOutputTokens
            .map((obj) => obj['text'])
            .filter((text) => text.trim() !== '' && text !== '\r\n');

        return _.isEqual(_.sortBy(expectedOutputArray), _.sortBy(outputTokensArray));
    };

    const checkAndProceed = (userInput) => {
        if (props?.live_assessment) {
            setLiveAssessmentData({
                assessmentData: [...liveAssessmentData.assessmentData, { question: steps[currentStep]?.instructions, answer: userInput }]
            })
            const correctAnswer = outputCompare(output);

            if (correctAnswer) {
                setLiveAssessmentData((prevData) => ({
                    ...prevData,
                    score: liveAssessmentData.score + 1
                }))
            } else {
                setLiveAssessmentData((prevData) => ({
                    ...prevData,
                    score: liveAssessmentData.score
                }))
            }
            moveToNext();
            return;
        }

        let isCorrectStep;
        if (steps[currentStep]?.exp_input && !isContainerLab) {
            isCorrectStep = inputCompare(userInput)
        } else {
            if (isContainerLab) {
                const normalise = (str) => {
                    if (Array.isArray(str)) {
                        str = str.join('');
                    }
                    if (typeof str !== 'string') {
                        str = String(str || '')
                    }
                    return str.replace(/\r?\n/g, '\n').replace(/\s+/g, ' ').trim();
                }
                isCorrectStep = normalise(output) === normalise(steps[currentStep]?.exp_output);
            } else {
                isCorrectStep = steps[currentStep]?.exp_input
                    ? inputCompare(output)
                    : outputCompare(output);
            }
        };

        if (!isCorrectStep) {
            handleIncorrectAttempt();
            return;
        }

        moveToNext();
        setIsExecuted(false);
    };

    useEffect(() => {
        if (!steps) return;

        if (audioRef.current) {
            audioRef.current.pause();
        }

        const audioLink = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}${steps[currentStep]?.voice}`;
        if (audioLink && !isMuted) {
            const newAudio = new Audio(audioLink);
            audioRef.current = newAudio;
            newAudio.play();
        }

        return () => {
            if (audioRef.current) {
                audioRef.current.pause();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStep, isMuted]);

    useEffect(() => {
        if (!nodeFinished) return;

        if (audioRef.current) {
            audioRef.current.pause();
        }

        const audio = new Audio(finalAudio);
        finalAudioRef.current = audio;
        audio.play();

        viewContext.notification.show(
            props.t('Labs.Nodes.NodeAutomation.end'),
            'info',
            false
        );

        return () => {
            if (finalAudioRef.current) {
                finalAudioRef.current.pause();
            }
        };

    }, [nodeFinished])

    const handleFinish = () => {
        setLoadingScreen(true);
        const formData = {
            sessionId
        };
        const options = {
            method: 'POST',
            url: `/api/user/labs/${lab_id}/nodes/${node_id}/end`,
            headers: {
                accept: 'application/json',
            },
            data: {
                saveCode: !!nodeInfo?.resource?.config?.saveCode,
                ...formData
            },
        };
        if (nodeInfo.is_assessment === 1) {
            options.data.completionPercent = roundedPercentage
        }
        axios
            .request(options)
            .then(async function (response) {
                await new Promise((resolve) => setTimeout(resolve, 50)); // Adding a wait for api post to happen
                if (nodeInfo?.is_assessment) {
                    setLoadingScreen(false);
                    navigate(`/labs/${lab_id}/nodes`);
                } else {
                    setLoadingScreen(false);
                    navigate(`/labs/${lab_id}/nodes/${node_id}/quiz/attempt`);
                }
                localStorage.removeItem('sessionId');
            })
            .catch((err) => {
                setLoadingScreen(false);
                let status = err.response.status;
                console.log('error', status);
                navigate('/oops');
            });
    };

    const navigate = useNavigate();

    const navigateBack = () => {
        navigate(-1);
    };

    const startLabClick = async () => {

        if (props?.live_assessment) {
            setStartLab(false);
            return;
        }

        if (isContainerLab) {
            setLoadingContainerStart(true);
        }
        const options = {
            method: 'POST',
            url: `/api/user/labs/${lab_id}/nodes/${node_id}/start`,
            headers: {
                accept: 'application/json',
            },
            data: {
                saveCode: !!nodeInfo?.resource?.config?.saveCode,
                ...(isContainerLab && { resource: nodeInfo.resource })
            }
        };
        await axios
            .request(options)
            .then((response) => {
                new Promise((resolve) => setTimeout(resolve, 100));
                setStartLab(false);
                if (isContainerLab) {
                    setLoadingContainerStart(false);
                }
                if (context?.user?.stop_walkthrough?.includes(nodeInfo?.resource?.lab_resource_id) || nodeInfo.is_assessment === 1) {
                    setIsMuted(!isMuted)
                }
                localStorage.setItem('sessionId', response.data.session_id);
                setIPAddress(response?.data?.user_ip)

                if (isContainerLab) {
                    startActivityTimer();
                }
            })
            .catch((err) => {
                setLoadingContainerStart(false);
                if (err.response.status === 403) {
                    navigate('/nopermission');
                } else {
                    navigate('/oops');
                }
            });
    };

    const handleCloseClick = () => {
        setShowOutput(false);
        setTimeout(() => {
            setAction('Output:');
        }, 500); // adding delay as setAction is noticeable from UI
    };


    const onUserInputChange = (value) => {
        resetActivityTimer();
        setDisableRunBtn(value?.length ? false : true);
        savedCode.current[currentStep] = value;
        setIsExecuted(false);
    };

    const handleRevealJS = async () => {
        if (nodeInfo?.resource?.config?.transpileCode) {
            const transpiledCodeBlock = await transpileTypeScriptToJavaScript(savedCode.current[currentStep] ?? '');
            setTranspiledCode(transpiledCodeBlock);
            setAction('Compiled JS:'); // Set the action for 'Reveal JS' button
        }
        setShowOutput(true);
    };
    const resetWalkthrough = (data) => {
        if (data.status === 'finished' | data.action === 'skip' | data.action === 'tour:end') {
            setIsMuted(!isMuted)
        }
    }
    useEffect(() => {
        const resourceIncluded = context?.user?.stop_walkthrough?.includes(nodeInfo?.resource?.lab_resource_id);
        if (resourceIncluded && !startLab) {
            setIsMuted(!isMuted)

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context?.user?.stop_walkthrough])

    const showConfirm = () => {
        setShowFinishConfirm(true);
    }

    const handleConfirmClick = () => {
        handleFinish();
    }

    const handleLiveAssessmentFinish = () => {

        try {
            const totalQuestions = liveAssessmentData.assessmentData.length;
            liveAssessmentData.percentage = Math.ceil(100 * liveAssessmentData.score / totalQuestions)
            const options = {
                method: 'PATCH',
                url: `/api/job/${job_id}/assessment_answers`,
                headers: {
                    accept: 'application/json'
                },
                data: {
                    answers: liveAssessmentData,
                }
            }

            axios
                .request(options)
                .then(response => {
                    if (response.status === 200) {
                        viewContext.notification.show(response.data.message, 'success', true);
                        navigate(`/hiring/jobs/${job_id}/applied`)
                    } else {
                        viewContext.notification.show(response.data.message, 'error', true);
                    }
                })
                .catch((err) => {
                    let status = err.response
                    console.log('error', status)
                    viewContext.notification.show(props.t('Labs.Nodes.NodeAutomation.notification.error'), 'error', true);
                    // navigate('/oops');
                })
        } catch (error) {
            viewContext.notification.show(props.t('Labs.Nodes.NodeAutomation.notification.error'), 'error', true);
        }

    }

    function setOutputText() {
        switch (action) {
            case 'Output:':
                if (nodeInfo?.resource?.config?.isAutomation) {
                    if (steps[currentStep]?.media?.length) {
                        return <MediaGrid
                            mediaLinks={steps[currentStep].media}
                        />
                    } else if (output?.length > 0) {
                        return output;
                    } else {
                        return props.t('Labs.Nodes.NodeAutomation.output.default');
                    }
                } else {
                    if (output?.length) {
                        return output
                    } else {
                        return props.t('Labs.Nodes.NodeAutomation.output.default');
                    }
                }
            case 'Compiled JS:':
                return <CodeBlock t={props.t} language="typescript" value={transpiledCode} isCopyEnabled={false} handleCopyDisabled={handleCopyDisabled} />
            default:
                if (output?.length) {
                    return output
                } else {
                    return props.t('Labs.Nodes.NodeAutomation.output.default');
                }
        }
    }

    const handleClick = (tableName) => {
        if (open === tableName) {
            setOpen('')
        } else {
            setOpen(tableName);
        }
    };
    const handleRefresh = () => {
        window.location.reload();
    };

    const handleGoBack = async () => {
        await handleContainerDelete();
        navigate(-1);
    };

    const resetActivityTimer = () => {
        clearTimeout(activityTimerRef.current);
        startActivityTimer();
    };

    function handleInactivity() {
        setLoadingContainerStart(false);
        setShowOutput(false);
        setShowReloadConfirm(true);
        handleContainerDelete();
    }

    const handleContainerDelete = () => {
        const sessId = localStorage.getItem('sessionId');
        const options = {
            method: 'DELETE',
            url: `/api/container-instances`,
            data: { "sessionId": sessId },

            headers: {
                accept: 'application/json',
            },
        };

        axios
            .request(options)
            .then(() => {
                localStorage.removeItem('sessionId');
            });
    };

    const sendHeartbeat = () => {
        const formData = {
            node_id: node_id,
        };
        const options = {
            method: 'POST',
            url: `/api/container-instances/heartbeat`,
            headers: {
                accept: 'application/json',
            },
            data: formData,
        };

        axios
            .request(options)
    };

    useEffect(() => {
        //send heartbeat call every 4 mins
        const heartBeatId = setInterval(sendHeartbeat, 240000);

        return () => {
            clearInterval(heartBeatId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (loadingContainerStart) {
            const interval = setInterval(() => {
                setProgress((prevProgress) => (prevProgress >= 95 ? 100 : prevProgress + 0.5));
            }, 1000);

            if (!loadingContainerStart) {
                clearInterval(interval);
            }
            return () => {
                clearInterval(interval);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingContainerStart]);

    return (
        <>
            {/* container loading animation */}
            <ContainerLoader 
                progress={progress} 
                loadingContainerStart={loadingContainerStart} 
                containerHints={nodeInfo?.container_loader_json} 
            />
            
            {loading ? (
                <div>
                    <LoadingBackdrop isOpen={true} />
                </div>
            ) : steps ? (
                <>
                    <ToastContainer
                        id="warning-toast"
                        position="top-right"
                        autoClose={10000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        limit={4}
                    />
                    <BackConfirmationCard
                        isSaveAvailable={true}
                        isContainerLab={isContainerLab}
                        sessionId={sessionId}
                    />
                    {
                        isContainerLab && (
                            <ConfirmationCard
                                title={props.t("Labs.Nodes.NodeAutomation.container.timeout.title")}
                                body={props.t("Labs.Nodes.NodeAutomation.container.timeout.body")}
                                showCard={showReloadConfirm}
                                setShowCard={setShowReloadConfirm}
                                handleCancel={handleGoBack} // Pass the refresh handler
                                handleConfirm={handleRefresh} // Pass the go back handler
                                confirmButtonText={props.t('Labs.Nodes.NodeAutomation.container.button.refresh')}
                                cancelButtonText={props.t('Labs.Nodes.NodeAutomation.container.button.goBack')}
                            />
                        )}
                    <ConfirmationCard
                        title={
                            isContainerLab ?
                                props.t(`Labs.Nodes.NodeAutomation.container.start.title.${nodeInfo?.is_assessment ? "assessment" : "default"}`)
                                : props.t(`Labs.Nodes.NodeAutomation.confirm.start.${nodeInfo?.is_assessment ? "assessment.title" : "default.title"}`)
                        }
                        body={
                            isContainerLab ?
                                props.t("Labs.Nodes.NodeAutomation.container.start.body")
                                : props.t(`Labs.Nodes.NodeAutomation.confirm.start.${nodeInfo?.is_assessment ? "assessment.body" : "default.body"}`)
                        }
                        showCard={startLab}
                        setShowCard={setStartLab}
                        handleCancel={navigateBack}
                        handleConfirm={startLabClick}
                    />
                    {!startLab && nodeInfo.is_assessment !== 1 ? (
                        <Joyride
                            open={nodeInfo?.resource?.walkthrough?.open}
                            run={nodeInfo?.resource?.walkthrough?.run}
                            steps={nodeInfo?.resource?.walkthrough?.steps || []}
                            resourceId={nodeInfo?.resource?.lab_resource_id}
                            disableOverlay={true}
                            callback={resetWalkthrough}
                        />
                    ) : null}
                    <div id="titleContainer" className={ImportedStyles.titleContainer}>
                        <div style={{ display: 'flex' }}>
                            <Avatar
                                sx={{
                                    bgcolor: pink[500],
                                    alignSelf: 'center',
                                    mr: 1,
                                    width: 55,
                                    height: 55,
                                }}
                            >
                                <SmartToyIcon sx={{ width: 42, height: 42 }} />
                            </Avatar>
                            <Typography
                                variant="h3"
                                sx={{
                                    textTransform: 'uppercase',
                                    color: '#76EAD7',
                                }}
                            >
                                {nodeInfo.name}
                            </Typography>
                        </div>
                        <span style={{ display: 'flex', flexDirection: 'row' }}>
                            <LightTooltip
                                title={
                                    nodeInfo.is_assessment
                                        ? ((roundedPercentage > 70) || nodeFinished ?
                                            props.t('Labs.Nodes.NodeAutomation.tooltip.finish.done')
                                            : props.t('Labs.Nodes.NodeAutomation.tooltip.finish.assessment')
                                        )
                                        : (nodeFinished ?
                                            props.t('Labs.Nodes.NodeAutomation.tooltip.finish.done')
                                            : props.t('Labs.Nodes.NodeAutomation.tooltip.finish.info')
                                        )
                                }
                                arrow
                                placement="left"
                                classes={{
                                    tooltip: {
                                        backgroundColor: '#fff',
                                        color: 'rgba(0, 0, 0, 0.87)',
                                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
                                        fontSize: 11,
                                    },
                                }}
                            >
                                <span>
                                    <button
                                        variant="extended"
                                        className={Styles.finishButton}
                                        onClick={() => {
                                            props?.live_assessment ? handleLiveAssessmentFinish() :
                                                nodeInfo.is_assessment ? showConfirm() : handleFinish()
                                        }}
                                        disabled={
                                            props.live_assessment ? false :
                                                !nodeInfo.is_assessment
                                                    ? !nodeFinished
                                                    : roundedPercentage < 70
                                        }
                                    >
                                        <KeyboardDoubleArrowRightIcon />
                                        {props.t('Labs.Nodes.NodeAutomation.button.finish')}
                                    </button>
                                </span>
                            </LightTooltip>
                            <ConfirmationCard
                                title={
                                    (roundedPercentage > 70 && roundedPercentage < 100) ?
                                        props.t('Labs.Nodes.NodeAutomation.confirm.completed.title.warn')
                                        : props.t('Labs.Nodes.NodeAutomation.confirm.completed.title.default')
                                }
                                body={(roundedPercentage > 70 && roundedPercentage < 100) ?
                                    props.t('Labs.Nodes.NodeAutomation.confirm.completed.body.warn')
                                    : props.t('Labs.Nodes.NodeAutomation.confirm.completed.body.default')
                                }
                                showCard={showFinishConfirm}
                                setShowCard={setShowFinishConfirm}
                                handleConfirm={handleConfirmClick}
                            />
                            {!props?.live_assessment && (
                                <NodeProgress
                                    lab_id={lab_id}
                                    node_id={node_id}
                                    currentStep={currentStep}
                                    setDrawerOpen={setDrawerOpen}
                                    drawerOpen={drawerOpen}
                                    setCurrentStep={setCurrentStep}
                                    initialUserProgress={nodeInfo.userProgress}
                                    steps={steps}
                                    data={data}
                                    resource={nodeInfo?.resource}
                                    onReveal={() => setShowReveal(true)}
                                    nodeInfo={nodeInfo}
                                    maxUnlocked={maxUnlocked}
                                    setMaxUnlocked={setMaxUnlocked}
                                    modifiedCode={modifiedCode.current}
                                    sessionId={sessionId}
                                />
                            )}
                        </span>
                    </div>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={showOutput}
                        onClick={handleCloseClick}
                    >
                        {nodeInfo?.resource?.config?.language === 'html' ? (
                            <div style={{
                                backgroundColor: '#f5f5f5',
                                width: '80%',
                                margin: '0 auto',
                                padding: '20px',
                                borderRadius: '5px',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                            }}>
                                <div style={{ display: 'flex', width: '100%', justifySelf: 'flex-end', justifyContent: 'flex-end' }}>
                                    <Badge
                                        aria-label="Close Explanation"
                                        badgeContent={<CloseIcon className={Styles.closeBadge} sx={{ fontSize: 30 }} />}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        onClick={handleCloseClick}
                                        sx={{
                                            cursor: 'pointer',
                                        }}
                                    >
                                    </Badge>
                                </div>
                                <iframe
                                    title="htmlOutput"
                                    srcDoc={output}
                                    style={{
                                        width: '100%',
                                        height: '500px',
                                        border: 'none',
                                        borderRadius: '8px',
                                        backgroundColor: 'white',
                                        boxShadow: 'inset 0 0 10px rgba(0, 0, 0, 0.1)'
                                    }}
                                />
                            </div>
                        ) : (
                            <div
                                id="outputWindow"
                                ref={outputRef}
                                className={`${CodeEditorStyles.outputWindow} ${Styles.outputWindow}`}
                                style={{ marginTop: '20px', fontFamily: 'monospace' }}
                            >
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            width: '100%',
                                            justifySelf: 'flex-start',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                        }}
                                    >
                                        {action}
                                    </div>
                                    <div style={{ display: 'flex', width: '100%', justifySelf: 'flex-end', justifyContent: 'flex-end' }}>
                                        <Badge
                                            aria-label="Close Explanation"
                                            badgeContent={<CloseIcon className={Styles.closeBadge} sx={{ fontSize: 30 }} />}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            onClick={handleCloseClick}
                                            sx={{
                                                cursor: 'pointer',
                                            }}
                                        >
                                        </Badge>
                                    </div>
                                </div>
                                {setOutputText()}
                            </div>
                        )}
                    </Backdrop>
                    <div className={Styles.superAncestor}>
                        <div className={Styles.innerCont} style={{ display: "flex" }}>
                            <div id="midContainer" className={`${Styles.midContainer}`}>
                                {nodeInfo?.resource?.config?.fileTreeRequired && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '6px' }}>
                                        <FolderOpenIcon
                                            id='fileTree'
                                            onClick={() => { setIsDrawerOpen(!isDrawerOpen); }}
                                            className={Styles.folderBtn}
                                            sx={{ fontSize: '4vh' }}
                                        />
                                        {(steps[currentStep]?.iframeUrl) && (
                                            <LaunchIcon
                                                onClick={() => { setIsWebPageOpen(!isWebPageOpen) }}
                                                className={Styles.folderBtn}
                                                sx={{ fontSize: '4vh' }}
                                            />
                                        )}
                                    </div>
                                )}
                                {(showTables) && (
                                    <>
                                        <List
                                            sx={{
                                                maxHeight: '100%',
                                                overflow: 'auto',
                                                width: '100%',
                                                borderRadius: "8px",
                                                maxWidth: 250,
                                                bgcolor: 'background.paper',
                                                margin: '4px 7px 4px 4px',
                                            }}
                                            component="nav"
                                            aria-labelledby="nested-list-subheader"
                                            subheader={
                                                <ListSubheader sx={{ borderRadius: "8px", fontSize: '1em', fontWeight: 'bold' }} component="div" id="nested-list-subheader">
                                                    Tables
                                                </ListSubheader>
                                            }
                                        >
                                            {tableInfo.map(({ tableName, fields }, index) => (
                                                <>
                                                    <ListItemButton key={index} onClick={() => { handleClick(tableName) }}>
                                                        <ListItemIcon>
                                                            <GridOnIcon fontSize='small' sx={{ color: '#FFCE4E' }} />
                                                        </ListItemIcon>
                                                        <ListItemText primary={
                                                            <div style={{ fontWeight: 'bold' }}>
                                                                {tableName}
                                                            </div>
                                                        } />
                                                        {open === tableName ? <ExpandLess /> : <ExpandMore />}
                                                    </ListItemButton>
                                                    <Collapse in={open === tableName} timeout="auto" unmountOnExit>
                                                        <div className={Styles.itemList}>
                                                            <List component="div" disablePadding>
                                                                {fields.map((field, fieldIndex) => (
                                                                    <ListItemText
                                                                        primary={
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8em', margin: '0px 10px' }}>
                                                                                <span style={{ fontWeight: 'bold' }}>{field.name}</span> <span>{field.type.toLowerCase()}</span>
                                                                            </div>
                                                                        }
                                                                    />
                                                                ))}
                                                            </List>
                                                        </div>
                                                    </Collapse>
                                                </>

                                            ))}
                                        </List>
                                    </>
                                )}
                                <div id="editorContainer"
                                    style={{
                                        height: '100%',
                                        width: '100%'
                                    }}
                                    className={CodeEditorStyles.editorContainer}
                                >
                                    <div
                                        id="editorWindow"
                                        className={Styles.editorWindow}
                                        onClick={() => { isDrawerOpen ? setIsDrawerOpen(!isDrawerOpen) : setIsDrawerOpen(isDrawerOpen) }}
                                    >
                                        <div className={SeleniumEditorStyles.folderStructure}
                                            style={{
                                                marginTop: "-2px"
                                            }}
                                        >
                                            <div
                                                className={SeleniumEditorStyles.treeContainer}
                                                hidden={!isDrawerOpen}
                                                style={{
                                                    // marginTop: "17px",
                                                    borderRadius: "8px"
                                                }}
                                            >
                                                <RenderFolderTree data={watcherData} />
                                            </div>
                                            <div
                                                className={SeleniumEditorStyles.backDrop}
                                                hidden={!isDrawerOpen}
                                                style={{
                                                    // marginTop: "17px",
                                                    borderTopRightRadius: "8px"
                                                }}
                                            >

                                            </div>
                                        </div>
                                        <div id="buttonContainer" className={Styles.bottomLeft}>
                                            {(nodeInfo?.resource?.config?.dbRequired) ?
                                                (
                                                    <button
                                                        id="showTableButton"
                                                        className={Styles.ButtonStyles}
                                                        onClick={() => { setShowTables(!showTables) }}
                                                    >

                                                        {showTables ?
                                                            props.t('Labs.Nodes.NodeAutomation.button.table.hide') :
                                                            props.t('Labs.Nodes.NodeAutomation.button.table.show')}
                                                        <FeatherIcon icon='database' />
                                                    </button>
                                                )
                                                : null
                                            }
                                            <button
                                                id="runButton"
                                                className={`${Styles.ButtonStyles}`}
                                                onClick={() => handleRun(nodeInfo?.resource)}
                                                disabled={disableRunBtn}
                                            >
                                                {props.t('Labs.Nodes.NodeAutomation.button.run')}
                                                <PlayCircleOutlineIcon fontSize='small' />
                                            </button>
                                            {(nodeInfo?.resource?.config?.transpileCode) && (
                                                <button
                                                    id="revealJSButton"
                                                    className={`${Styles.ButtonStyles}`}
                                                    onClick={handleRevealJS}
                                                    disabled={disableRunBtn}
                                                >
                                                    {props.t('Labs.Nodes.NodeAutomation.button.revel')}
                                                    <VisibilityIcon fontSize='small' />
                                                </button>
                                            )}
                                            <button
                                                id="verifyButton"
                                                className={`${Styles.ButtonStyles}`}
                                                disabled={!isExecuted || readOnly}
                                                onClick={() => { checkAndProceed(savedCode.current[currentStep] ?? ""); }}
                                                title={isExecuted ? '' : props.t('Labs.Nodes.NodeAutomation.tooltip.verify')}
                                            >
                                                {props.t('Labs.Nodes.NodeAutomation.button.verify')}
                                                <RuleIcon fontSize='small' />
                                            </button>
                                        </div>
                                        <div className={Styles.editorBox}>
                                            <MonacoEditor
                                                value={savedCode.current[currentStep] ?? ''}
                                                width={showTables ? "40vw" : "42vw"}
                                                height="88.2vh"
                                                theme="vs-light"
                                                defaultLanguage={nodeInfo?.resource?.config?.language || 'javascript'}
                                                defaultValue={nodeInfo?.resource?.config?.codeTemplate || ''}
                                                onChange={onUserInputChange}
                                                options={{
                                                    minimap: {
                                                        enabled: false,
                                                    },
                                                    scrollbar: {
                                                        vertical: 'hidden',
                                                        alwaysConsumeMouseWheel: false,
                                                    },
                                                    fontSize: 16,
                                                    wordWrap: 'on',
                                                    glyphMargin: false,
                                                    folding: false,
                                                    lineDecorationsWidth: 10,
                                                    lineNumbersMinChars: 2,
                                                    glyphMarginDecorationLaneCount: 0,
                                                    overviewRulerLanes: 0,
                                                    readOnly: readOnly
                                                }}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={Styles.innerCont} style={{ maxHeight: 'calc(100vh - 0.2em)' }}>
                            <div data-testid="nodeAutomation-superAncestor-infoContainer" id="infoContainer" className={Styles.infoContainer}>
                                <InstructionPane
                                    props={props}
                                    steps={steps}
                                    currentStep={currentStep}
                                    isMuted={isMuted}
                                    copied={copied}
                                    setIsMuted={setIsMuted}
                                    isCopyEnabled={isCopyEnabled}
                                    onHandleCopy={handleCopy}
                                    onHandleVoiceClick={handleVoiceClick}
                                    onHandleCopyDisabled={handleCopyDisabled}
                                    onHandleCopyButton={handleCopyButton}
                                    nodeInfo={nodeInfo}
                                    setIsWebPageOpen={setIsWebPageOpen}
                                    isWebPageOpen={isWebPageOpen}
                                    theme='light'
                                />
                            </div>
                        </div>
                        {(!startLab && !nodeFinished && nodeInfo?.is_assessment !== 1 && !props?.live_assessment && nodeInfo?.resource?.config?.chatbotTopic) && (
                            <HelperChat
                                active={props.aiChat}
                                topic={nodeInfo?.resource?.config?.chatbotTopic}
                            />
                        )}
                        {!props?.live_assessment && <InfoDrawer
                            handleDrawer={handleDrawer}
                            drawerOpen={drawerOpen}
                            titleText={props.t('Labs.Nodes.NodeAutomation.reference', { LabName: nodeInfo.labName })}
                            displayData={nodeInfo?.content?.reference_data}
                        />}
                        <span id="codeEditorTimeLine" className={Styles.codeEditorTimeLine}>
                            <NodeTimeline
                                nodeFinished={nodeFinished}
                                currentStep={currentStep}
                                steps={steps}
                                currentRef={currentRef}
                                hideToolTip={true}
                                collapsable={true}
                                setCurrentStep={setCurrentStep}
                                maxUnlocked={maxUnlocked}
                            />
                        </span>
                    </div>
                    {nodeFinished && <Feedback isInNode={true} nodeName={nodeInfo.name} labName={nodeInfo.labName} />}

                    <RevealAnswerKey
                        showAnswerKeyDialog={showReveal}
                        setShowAnswerKeyDialog={setShowReveal}
                        steps={steps}
                        currentStep={currentStep}
                        language={nodeInfo?.resource?.config?.language}
                        nodeId={node_id}
                        nodeName={nodeInfo?.name}
                        labTitle={nodeInfo?.labName}
                    />
                </>
            ) : (
                <div>
                    <LoadingBackdrop isOpen={true} />
                </div>
            )
            }
        </>
    );
}
